// extracted by mini-css-extract-plugin
export default {"wrapper":"PayPal_wrapper__aUEk9","spinner":"PayPal_spinner__38MCS"};